<style scoped>

  #documents-segment {
    min-height: 340px;
  }

</style>

<template>

  <div>

    <div class="ui segment">
      <h4 class="ui dividing header">Dados da Ficha</h4>
      <div class="ui form">          
        <div class="fields">
          <div class="five wide field">
            <label class="form-label">Clínica</label>
            {{ registration.customer.name }}
          </div>                                          
          <div class="three wide field">
            <label class="form-label">Animal</label>
            {{ registration.animal.name }}
          </div>  
          <div class="two wide field">
            <label class="form-label">Sexo</label>
            <i :class="animalSex.icon"></i> {{ animalSex.label }}
          </div>  
          <div class="three wide field">
            <label class="form-label">Raça</label>
            {{ registration.animal.race.name }}
          </div>      
          <div class="three wide field">
            <label class="form-label">Espécie</label>
            {{ registration.animal.race.species.name }}
          </div>                                                                                      
        </div>
        <div class="fields">
          <div class="five wide field">
            <label class="form-label">Tutor</label>
            {{ registration.owner.name }}
          </div> 
          <div class="five wide field">
            <label class="form-label">Númera da Ficha</label>
            {{ registration.registrationId }}
          </div> 
        </div>
      </div>
    </div> 

    <div id="documents-segment" class="ui segment">        
      <h4 class="ui dividing header">
        Documentos
        <span v-if="$isSimavet()" class="ui label">Público</span>
      </h4>
      <file-upload
        ref="fileUpload"
        :basic="true"
        :readOnly="!$isSimavet()"
        :uploadPath="`/animal-registrations/${this.registration.id}/attachments`"
        :loader="loadFiles"        
        @onRemove="onRemoveFile"
      />
    </div> 

  </div>

</template>

<script>

  import AnimalRegistrationService from "@/services/animal-registration-service"  
  import FileUpload from "@/components/file-upload"

  export default {
    
    name: "AnimalRegistrationOverview",

    data() {
      return {
        service: new AnimalRegistrationService(),
      }
    },    

    props: ["registration"],

    components: {
      FileUpload,
    },

    mounted() {
      this.$refs.fileUpload.loadFiles()
    },

    computed: {

      animalSex() {

        let sex = { icon: "", label: "" }  

        if (!this.registration.animal)
          return sex

        if (this.registration.animal.sex == "male") {
          sex = { icon: "mars blue icon", label: "Macho" }
        } else if (this.registration.animal.sex == "female") {
          sex = { icon: "venus pink icon", label: "Fêmea" }
        } else if (this.registration.animal.sex == "undefined") {
          sex = { icon: "question circle grey icon", label: "Indefinido" }
        }

        return sex
      },
    },

    methods: {

      async loadFiles() {
        return this.service.getAttachments(this.registration.id)        
      }, 

      async onRemoveFile(file) {

        try {

          await this.service.removeAttachment(this.registration.id, file)           
          
        } catch (error) {
          
          this.$errorHandler(error)
        }
      },
    },
  }

</script>